// Constants
export const datos_contacto = () => {
    return {
        datos_contacto: {
            id: {
                namepath: ['admin_centros'],
                type: "number",
                label: "id",
                placeholder: "",
                description: "",
                validate: "",
                datatype: {
                    type: "input",
                    disabled: true,
                    predeterminate: null,
                }
            },
            id_list_estado: {
                type: "text",
                label: "Estado",
                placeholder: "",
                namepath: ['admin_centros'],
                description: "",
                validate: "",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: 1,
                    list: "list_estado",
                    label: 'name'
                }
            },
            name: {
                type: "text",
                label: "Nombre",
                placeholder: "",
                namepath: ['admin_centros'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            direccion: {
                type: "text",
                label: "Dirección",
                placeholder: "",
                namepath: ['admin_centros'],
                description: "",
                validate: "",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            email: {
                type: "text",
                label: "Email",
                placeholder: "",
                namepath: ['admin_centros'],
                description: "",
                validate: "",
                datatype: {
                    type: "email",
                    disabled: false,
                    predeterminate: null,
                }
            },
            telefonos: {
                type: "number",
                label: "Telefonos",
                placeholder: "",
                namepath: ['admin_centros'],
                description: "",
                validate: "",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: '',
                    prepend: '',
                    append: '',
                }
            },
            documento: {
                type: "number",
                label: "Documento",
                placeholder: "",
                namepath: ['admin_centros'],
                description: "",
                validate: "required",
                datatype: {
                    type: "price",
                    disabled: false,
                    predeterminate: '',
                    prepend: '',
                    append: '',
                }
            },
            nota_delete: {
                type: "text",
                label: "Nota",
                placeholder: "",
                namepath: [''],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null
                }
            },
        }
    }
}